// Import the state interface and our combined reducers/sagas.
import { ApplicationState, rootReducer, rootSaga } from './store';
import { Store } from 'redux';
import { configureStore } from '@reduxjs/toolkit';

import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { navigationMiddleware } from '../src/store/middleware/navigationMiddleware';
import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant'; // Import the middleware
import { Middleware, Dispatch, AnyAction } from 'redux';

export const history = createBrowserHistory();

export default function configureStoreProdatex(
  initialState: ApplicationState
): Store<ApplicationState> {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
      const defaultMiddleware = getDefaultMiddleware({
        thunk: false, // Disable thunk middleware if unnecessary
      });

      const customMiddlewares: Middleware<{}, any, Dispatch<AnyAction>>[] = process.env.REACT_APP_ENV !== 'production' 
        ? [immutableStateInvariantMiddleware()]
        : [];

      // Return a tuple containing default and custom middleware
      return defaultMiddleware
        .concat(sagaMiddleware, navigationMiddleware, ...customMiddlewares);
    },
    devTools: process.env.REACT_APP_ENV !== 'production',
    preloadedState: initialState,
  });

  // Run the root saga
  sagaMiddleware.run(rootSaga);

  return store;
}




